import React from 'react';
const Send2SVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      className={className}
      {...props}
    >
      <rect width='27.9964' height='28' rx='13.9982' fill='black' />
      <path
        d='M20.9503 8.93403L16.6431 19.5616C16.4583 20.0176 15.8474 20.1476 15.4775 19.8096L13.0496 17.5915L11.5614 19.0129C11.3353 19.2289 10.9487 19.0759 10.9487 18.7705V15.6721L7.22211 12.2674C6.81529 11.8958 6.9943 11.2418 7.53954 11.1079L20.1021 8.02247C20.6677 7.88351 21.1611 8.41372 20.9503 8.93403ZM19.2041 9.71501L11.3303 14.6197L12.5762 15.7579L19.2041 9.71501Z'
        fill='white'
      />
    </svg>
  );
};

export default Send2SVG;
